export default __webpack_public_path__ + "static/media/location.20b625ab.svg";